export const openModalPreventScroll = () => {
  window.scrollTo(0, 0);
  document.body.style.overflow = 'hidden'; // Prevent background scrolling
}

export const closeModalRestoreScroll = () => {
  document.body.style.overflow = ''; // Restore background scrolling
}
